import styled from 'styled-components';

interface IThumbnailContainer {
    activeThumbnail: ActiveThumbnail
    left: number
    isVisible: boolean
}
interface ActiveThumbnail {
    end: number
    x: number
    y: number
    width: number
    height: number
    imageHeight: number
    imageWidth: number
    start: number
    url: string
}

export const staticSize = {
    height: 161,
    width: 263,
};

export const ThumbnailContainer = styled.div.attrs<IThumbnailContainer>(
    ({ activeThumbnail, left, isVisible }) => {
        const scale = 1;
        const finalHeight = activeThumbnail.height / scale;
        const finalWidth = activeThumbnail.width / scale;

        const borderRadiosScaled = 8 / scale;

        return {
            style: {
                bottom: 60,
                left,
                height: `${finalHeight}px`,
                width: `${finalWidth}px`,
                marginLeft: `-${finalWidth / 2}px`,
                display: `${isVisible ? 'flex' : 'none'}`,
                backgroundImage: `url("${activeThumbnail.url}")`,
                backgroundPositionX: `-${activeThumbnail.x}px`,
                backgroundPositionY: `-${activeThumbnail.y}px`,
                transform: `scale(${scale})`,
                transformOrigin: 'bottom center',
                borderRadius: `${borderRadiosScaled}px`,
            },
        };
    }
) <IThumbnailContainer>`
    position: absolute;
    flex-direction: row;
    justify-content: center;
    background: ${(props) => props.color};
`;

ThumbnailContainer.displayName = 'ThumbnailContainer';
